import TravelExploreIcon from '@mui/icons-material/TravelExplore'
import VerifiedIcon from '@mui/icons-material/Verified'
import { Box, Button, Divider, Stack, Typography } from '@mui/material'
import { teal } from '@mui/material/colors'
import { useTranslation } from 'react-i18next'
import { Outlet, useNavigate } from 'react-router'
import authBackground from '../assets/images/AuthBackground.png'
import logo from '../assets/images/logo.svg'
import passportPreview from '../assets/images/PassportPreview.png'

export default function AuthLayout() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        height: '100vh',
        position: 'relative',
        background: `linear-gradient(62deg, #171B1E 35.34%, rgba(49, 49, 49, 0.64) 101.43%), url(${authBackground}) lightgray 50% / cover no-repeat`
      }}
    >
      <Stack direction='row' sx={{ height: '100%' }}>
        <Stack
          sx={{
            width: '50%',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '2rem',
            overflow: 'hidden'
          }}
        >
          <img
            alt='Sosteval-Tec logo'
            src={logo}
            style={{ width: '28.125rem' }}
          />
          <Divider
            sx={{
              width: '4rem',
              borderColor: teal.A400,
              borderWidth: '1.5px'
            }}
          />
          <Stack
            direction='row'
            sx={{
              alignItems: 'center',
              gap: '2rem'
            }}
          >
            <Box
              sx={{
                flexShrink: 0,
                maxWidth: '14rem',
                borderRadius: '0.625rem',
                overflow: 'hidden',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
                opacity: 0.85,
                transform: 'perspective(800px) rotateY(3deg)',
                transition: 'opacity 0.3s, transform 0.3s',
                '&:hover': {
                  opacity: 1,
                  transform: 'perspective(800px) rotateY(0deg)'
                }
              }}
            >
              <img
                alt='Preview de Pasaporte Digital'
                src={passportPreview}
                style={{ width: '100%', display: 'block' }}
              />
            </Box>
            <Stack sx={{ gap: '1rem' }}>
              <Stack
                direction='row'
                sx={{ alignItems: 'center', gap: '0.75rem' }}
              >
                <VerifiedIcon sx={{ fontSize: '2rem', color: teal.A400 }} />
                <Typography
                  variant='h5'
                  sx={{
                    color: '#E6EDF3',
                    fontWeight: 700,
                    letterSpacing: '-0.02em'
                  }}
                >
                  {t('public.auth_cta.title')}
                </Typography>
              </Stack>
              <Typography
                variant='body2'
                sx={{
                  color: '#8B949E',
                  maxWidth: '20rem',
                  lineHeight: 1.6
                }}
              >
                {t('public.auth_cta.description')}
              </Typography>
              <Button
                variant='outlined'
                startIcon={<TravelExploreIcon />}
                onClick={() => navigate('/search')}
                sx={{
                  textTransform: 'none',
                  color: teal.A400,
                  borderColor: teal.A400,
                  fontWeight: 600,
                  fontSize: '0.95rem',
                  px: 3,
                  py: 1,
                  alignSelf: 'flex-start',
                  '&:hover': {
                    backgroundColor: 'rgba(29, 233, 182, 0.08)',
                    borderColor: teal.A200,
                    color: teal.A200
                  }
                }}
              >
                {t('public.auth_cta.button')}
              </Button>
            </Stack>
          </Stack>
        </Stack>
        <Box
          sx={{
            width: '50%',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
          }}
        >
          <Box
            sx={{
              width: '50%',
              marginLeft: '10rem'
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </Stack>
    </Box>
  )
}
